import React, { useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fireCardComplete,
  flatCardComplete,
  gradientCardComplete,
} from "../../constant/imagePath";
import { _description } from "../../handlers/helperFunctions";
import { saveLocation } from "../../redux/common/commonSlice";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import MainCard from "../../stories/MainCard";
import classes from "./Template.module.css";
const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const navigate = useNavigate();

  // handleNavigate
  const handleNavigate = (index) => {
    if (index == 0) return navigate("/fire");
    if (index == 1) return navigate("/blaze", { state: true });
    if (index == 2) return navigate("/blaze");
  };
  return (
    <>
      <Header />
      <Container className={classes.container}>
        <div className={classes.inner_cont}>
          <div className={classes.choose_head}>
            <h2>CHOOSE TEMPLATE</h2>
          </div>
          <Row className={classes.inner_row}>
            {templateArray.map((data, i) => {
              return (
                <Col lg={4} md={6} key={i}>
                  <div className={classes.tempelate_head}>
                    <h4>Template {i + 1}</h4>
                  </div>
                  <div onClick={handleNavigate.bind(this, i)}>
                    <MainCard status={true} data={data} localPhoto />
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default Index;

const templateArray = [
  {
    _id: 1,
    photo: fireCardComplete,
    title: "Fire Card",
    description: _description,
  },
  {
    _id: 1,
    photo: flatCardComplete,
    title: "Flat Card",
    description: _description,
  },
  {
    _id: 1,
    photo: gradientCardComplete,
    title: "Gradient Card",
    description: _description,
  },
];
